<template>
  <div class="mobile mobile_index">
    <TopNav theme_="light" @goScroll="goScroll"></TopNav>
    <Banner></Banner>
    <div class="mobile_con">
      <div class="mobile_product">
        <div id="title_0" style="width:100%;height:2.4rem"></div>
        <div  class="mobile_title mobile_top_title">产品服务</div>
        <div
          v-for="(item, index) in product"
          :key="index"
          class="mobile_product_item"
        >
          <div
            class="mobile_product_item_head"
            :style="{
              backgroundColor: item.bcg_color,
              backgroundImage: 'url(' + item.bcg_img + ')',
              backgroundSize: '100%,100%',
              backgroundRepeat: 'no-repeat',
            }"
          >
            <img class="logo" src="../../assets/logo-touming.png" alt="" />
            <p style="margin-bottom: 1rem">{{ item.name }}</p>
            <p :style="{ color: item.font_color }">DINGHAN</p>
            <p :style="{ color: item.font_color }">TECHNOLOGY</p>
          </div>
          <div
            class="mobile_product_item_con"
            :style="{
              color: item.con_font_color,
              backgroundColor: item.font_bcg_color,
            }"
          >
            {{ item.desc }}
          </div>
        </div>
      </div>
    </div>
    <div id="title_1" style="width:100%;height:2.4rem"></div>
    <div class="mobile_kind" >
      <div
        class="mobile_kind_item"
        v-for="(item, index) in kind"
        :key="index"
        @click="go(item.path)"
      >
        <img :src="item.img" alt="" />
        <div>{{ item.title }}</div>
      </div>
    </div>
    <div id="title_2" style="width:100%;height:2.4rem"></div>
    
    <div class="mobile_news">
      <div    class="mobile_title">最新动态</div>
      <div
      
        class="mobile_news_item"
        v-for="(item, index) in newsList"
        :key="index"
      >
        <img :src="item.img" alt="" />
        <div class="mobile_news_item_con">
          <p>{{ item.title }}</p>
          <p>{{ item.detail }}</p>
        </div>
      </div>
    </div>
    <!-- <FooterDom></FooterDom> -->
    <mt-popup v-model="popupVisible" position="right">
      <div style="width: 10rem; height: 100vh; background: red"></div>
    </mt-popup>
  </div>
</template>

<script>
import TopNav from "./TopNav.vue";
import Banner from "./Banner.vue";
import { Popup } from "mint-ui";
export default {
  name: "",
  mixins: [],
  components: {
    TopNav,
    Banner,
    Popup,
  },
  props: {},
  data() {
    return {
      product: [
        {
          name: "投标保函",
          desc: "投标人购买投标保函等同于缴纳投标保证金，是在通过招采方式成交的工程建造项目中，投标方为响应招标方的要求，向保证人申请出具的保函，保证投标方履行招标文件的一种保函。",
          bcg_color: "#1A7FDD",
          font_color: "#F9E666",
          bcg_img: "",
          font_bcg_color: "#ffffff",
          con_font_color: "#000000",
        },
        {
          name: "合同履约保函",
          desc: "向建设工程发包人提供的保证承包人履行建设合同义务的保函，是担保人应被保证人申请向工程承包项目中的业主出具的，保证被保证人严格按照合同约定全面和实际地履行其合同责任和义务的一种保函。",
          bcg_color: "#1A7FDD",
          font_color: "#8BC7E1",
          bcg_img: require("../../../static/mobile/product_2.jpg"),
          font_bcg_color: "#ffffff",
          con_font_color: "#000000",
        },
        {
          name: "工程款支付保函",
          desc: "是指保证人为承包方向发包方提供的，在发包方预先支付一定数额款项以供承包方周转使用后，保证承包方在收到预付款后按施工合同约定专款专用的一种担保。",
          bcg_color: "#199EBC",
          font_color: "#8bfe95",
          bcg_img: "",
          font_bcg_color: "#ffffff",
          con_font_color: "#000000",
        },

        {
          name: "工程质量保函",
          desc: "工程质量保函，也称为“维修保函”，是指应供货方或承建人申请，向买方或业主保证，如货物或工程的质量不符合合同约定而卖方或承建人又不能依约更换或修理时，按买方或业主的索赔予以赔偿的书面文件。",
          bcg_color: "#1A7FDD",
          font_color: "#359125",
          bcg_img: require("../../../static/mobile/product_1.jpg"),
          font_bcg_color: "#e4e6e5",
          con_font_color: "#000000",
        },

        {
          name: "预付款保函",
          desc: "是指保证人为承包方向发包方提供的，在发包方预先支付一定数额款项以供承包方周转使用后，保证承包方在收到预付款后按施工合同约定专款专用的一种担保。",
          bcg_color: "#646FDD",
          font_color: "#CEACCC",
          bcg_img: require("../../../static/mobile/product_4.jpg"),
          font_bcg_color: "#ffffff",
          con_font_color: "#000000",
        },

        {
          name: "农民工工资支付保函",
          desc: "是指在建筑工程项目中为保证建设单位如期履行工人工资支付义务，由担保人为建设单位向监管人提供的，保证建设单位如期履行工人工资支付义务的担保。",
          bcg_color: "#646FDD",
          font_color: "#EDEFBD",
          bcg_img: "",
          font_bcg_color: "#ffffff",
          con_font_color: "#000000",
        },
      ],
      kind: [
        {
          img: require("../../../static/mobile/kind_0.jpg"),
          title: "公司简介",
          path: "/mBrief",
        },
        {
          img: require("../../../static/mobile/kind_1.jpg"),
          title: "保函服务",
          path: "/mService",
        },
        {
          img: require("../../../static/mobile/kind_2.jpg"),
          title: "合作伙伴",
          path: "/mPartner",
        },
      ],
      newsList: [
        {
          title: "鼎函科技签约江苏设备成套",
          detail: "鼎函科技江苏分公司近日与江苏省设备成套股份有限公司签约。",
          time: "2023-11-7",
          img: require("../../../static/mobile/news_0.png"),
        },
        {
          title: "鼎函科技签约中航金网",
          detail:
            "10月23日，鼎函科技有限公司与中航金网（北京）电子商务有限公司完成签约。",
          time: "2023-10-23",
          img: require("../../../static/mobile/news_1.png"),
        },
        {
          title: "鼎函科技拜访新疆产权交易所",
          detail: "9月12日，鼎函科技拜访新疆自治区产权交易所有限责任公司。",
          time: "2023-9-13",
          img: require("../../../static/mobile/news_2.png"),
        },
      ],
      popupVisible: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    go(path) {
      this.$router.push({ path: "/mobile" + path });
    },
    goScroll() {
      
    },
  },
};
</script>

<style scoped >
.mobile_index {
  width: 100%;
  min-height: 100vh;
  background: #fefefe;
  overflow-x: hidden;
}
.mobile_con {
  position: relative;
  width: 100%;
  height: 170rem;
  /* background: red; */
}
.mobile_product {
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: -12rem;
  z-index: 999;
}
.mobile_top_title {
  width: 21.5rem;
  border-top: 1px solid #ededee;
  /* background: #e27500; */
  padding-top: 1.4rem;
  margin-bottom: 2.2rem;
}
.mobile_product_item {
  width: 21.5rem;
  height: 27.94rem;
  box-shadow: inset 0 0 0 0 #ededee, 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 1rem;
}
.mobile_product_item_head {
  width: 100%;
  height: 12.56rem;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.mobile_product_item_head > p {
  font-size: 1.5rem;
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  font-weight: 700;
  margin-left: 1.3rem;
}

.mobile_product_item_head>.logo {
  width: 11.5rem;
  position: absolute;
  right: 1rem;
  top: 1rem;
}
.mobile_product_item_con {
  height: calc(100% - 12.56rem);
  background: #fff;
  padding: 2rem 2rem;
  box-sizing: border-box;
}
.mobile_kind {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 1rem;
}
.mobile_kind_item {
  width: 21.5rem;
  height: 10.625rem;
  position: relative;
  margin-bottom: 1rem;
}
.mobile_kind_item img {
  width: 100%;
  height: 100%;
}

.mobile_kind_item div {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-style: italic;
}
.mobile_news {
  background: rgb(26, 56, 98);
  padding: 1.87rem 0 1rem 0;
}
.mobile_news_item {
  position: relative;
  width: 21.31rem;
  height: 22.5rem;
  margin: auto;
  margin-bottom: 1rem;
}
.mobile_news_item img {
  width: 100%;
  height: 100%;
}
.mobile_news_item_con {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.22);
  position: absolute;
  left: 0;
  top: 0;
  padding: 6.2rem 1rem 1rem 1rem;
  box-sizing: border-box;
}
.mobile_news_item_con p:nth-child(1) {
  font-size: 1.5rem;
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  font-weight: 700;
  /* height: 4rem; */
}
.mobile_news_item_con p:nth-child(2) {
  margin-top: 1.4rem;
  font-style: italic;
  line-height: 1.7rem;
}
</style>
